import $ from 'jquery';
import 'select2';
import 'select2/dist/css/select2.css'

export default function workshopCategory() {
  $('#workshop_category_requirement_ids').select2()
  $('[data-toggle="tooltip"]').tooltip()  
}